module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vanguard-payment-form"
  }, [_c('span', {
    staticClass: "warning-message"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('form.warningMessage1click')))])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn btn-lg btn-green vanguard-validate-order-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.validateOrder.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.buttonLabel) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f468a0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/multiple/components/validate-order-button.vue
// module id = 979
// module chunks = 0